module.exports = __webpack_public_path__ + "img/rating_good.2e1160ce.svg";